export default "__VITE_ASSET__J$o6Witi__"